import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'bitRateFormat', standalone: true })
export class BitRateFormatPipe implements PipeTransform {
  transform(value: number): string {
    if (value == null || isNaN(value) || value === 0) return '';

    const units = ['bps', 'Kbps', 'Mbps', 'Gbps', 'Tbps'];
    let i = 0;
    let val = value;

    while (val >= 1000 && i < units.length - 1) {
      val /= 1000;
      i++;
    }

    return `${Math.round(val)} ${units[i]}`;
  }
}
